import {
    MergerAcquisitionListItem,
    MergerAcquisitionListResponse,
} from "@gsx/common/src/types/http/admin/mergerAcquisition";
import { Api } from "../../../../../common/src/api/Api";
import ListStoreVuex from "../../../../../common/src/stores/general/ListStoreVuex";
import { Module, RegisterOptions } from "vuex-class-modules";

@Module({ generateMutationSetters: true })
export class MergerAcquisitionsListStore extends ListStoreVuex<MergerAcquisitionListItem> {
    query: string = "";

    constructor(private readonly api: Api, options: RegisterOptions) {
        super(options);
        this.pageSize = 10;
    }

    protected async fetch(): Promise<MergerAcquisitionListResponse> {
        return this.api.admin.mergerAcquisition.list({
            ...this.queryParams,
            sort: this.sort || "announceDate",
            order: this.order,
            skip: `${this.pageSize * (this.page - 1)}`,
            take: `${this.pageSize}`,
            query: this.query,
        });
    }
}
